/**
 * Owner: Masa Bayu
 * File: qx-taxonomy-data-a.ts
 * Date:Time: 2026-10-19 11:40
 * Description: §405 — data taksonomi QX bahagian A (kategori 1–18: Academic
 *   hingga Science Fiction and Fantasy). Ikut piawaian Owner 2026-10-19.
 */
export const QX_TAXONOMY_DATA_A = Object.freeze([
    Object.freeze({
        id: 'academic',
        en: 'Academic',
        ms: 'Akademik',
        subcategories: Object.freeze([
            { id: 'academic.higher-education', en: 'Higher Education', ms: 'Pendidikan Tinggi' },
            { id: 'academic.university-textbooks', en: 'University Textbooks', ms: 'Buku Teks Universiti' },
            { id: 'academic.academic-reference-books', en: 'Academic Reference Books', ms: 'Buku Rujukan Akademik' },
            { id: 'academic.academic-monographs', en: 'Academic Monographs', ms: 'Monograf Akademik' },
            { id: 'academic.research-and-studies', en: 'Research and Studies', ms: 'Penyelidikan dan Kajian' },
            { id: 'academic.theses-and-dissertations', en: 'Theses and Dissertations', ms: 'Tesis dan Disertasi' },
            { id: 'academic.conference-proceedings', en: 'Conference Proceedings', ms: 'Prosiding Persidangan' },
            { id: 'academic.scholarly-journals', en: 'Scholarly Journals and Publications', ms: 'Jurnal dan Penerbitan Ilmuwan' },
            { id: 'academic.lecture-notes', en: 'Lecture Notes', ms: 'Nota Kuliah' },
            { id: 'academic.academic-workbooks', en: 'Academic Workbooks', ms: 'Buku Kerja Akademik' },
        ]),
    }),
    Object.freeze({
        id: 'science',
        en: 'Science',
        ms: 'Sains',
        subcategories: Object.freeze([
            { id: 'science.physics', en: 'Physics', ms: 'Fizik' },
            { id: 'science.chemistry', en: 'Chemistry', ms: 'Kimia' },
            { id: 'science.biology', en: 'Biology', ms: 'Biologi' },
            { id: 'science.astronomy-and-cosmology', en: 'Astronomy and Cosmology', ms: 'Astronomi dan Kosmologi' },
            { id: 'science.earth-science', en: 'Earth Science', ms: 'Sains Bumi' },
            { id: 'science.environmental-science', en: 'Environmental Science', ms: 'Sains Alam Sekitar' },
            { id: 'science.marine-science', en: 'Marine Science', ms: 'Sains Kelautan' },
            { id: 'science.genetics', en: 'Genetics', ms: 'Genetik' },
            { id: 'science.neuroscience', en: 'Neuroscience', ms: 'Neurosains' },
            { id: 'science.applied-science', en: 'Applied Science', ms: 'Sains Gunaan' },
            { id: 'science.general-science', en: 'General Science', ms: 'Sains Umum' },
        ]),
    }),
    Object.freeze({
        id: 'technology',
        en: 'Technology and Computing',
        ms: 'Teknologi dan Komputer',
        subcategories: Object.freeze([
            { id: 'technology.artificial-intelligence', en: 'Artificial Intelligence (AI)', ms: 'Kecerdasan Buatan (AI)' },
            { id: 'technology.computer-science', en: 'Computer Science', ms: 'Sains Komputer' },
            { id: 'technology.programming', en: 'Programming', ms: 'Pengaturcaraan' },
            { id: 'technology.software-engineering', en: 'Software Engineering', ms: 'Kejuruteraan Perisian' },
            { id: 'technology.data-science', en: 'Data Science', ms: 'Sains Data' },
            { id: 'technology.machine-learning', en: 'Machine Learning', ms: 'Pembelajaran Mesin' },
            { id: 'technology.cybersecurity', en: 'Cybersecurity', ms: 'Keselamatan Siber' },
            { id: 'technology.computer-networks', en: 'Computer Networks', ms: 'Rangkaian Komputer' },
            { id: 'technology.databases', en: 'Databases', ms: 'Pangkalan Data' },
            { id: 'technology.web-and-app-development', en: 'Web and Application Development', ms: 'Pembangunan Web dan Aplikasi' },
            { id: 'technology.robotics-and-automation', en: 'Robotics and Automation', ms: 'Robotik dan Automasi' },
            { id: 'technology.digital-technology', en: 'Digital Technology', ms: 'Teknologi Digital' },
        ]),
    }),
    Object.freeze({
        id: 'engineering',
        en: 'Engineering and Industry',
        ms: 'Kejuruteraan dan Industri',
        subcategories: Object.freeze([
            { id: 'engineering.civil', en: 'Civil Engineering', ms: 'Kejuruteraan Awam' },
            { id: 'engineering.mechanical', en: 'Mechanical Engineering', ms: 'Kejuruteraan Mekanikal' },
            { id: 'engineering.electrical', en: 'Electrical Engineering', ms: 'Kejuruteraan Elektrik' },
            { id: 'engineering.electronic', en: 'Electronic Engineering', ms: 'Kejuruteraan Elektronik' },
            { id: 'engineering.chemical', en: 'Chemical Engineering', ms: 'Kejuruteraan Kimia' },
            { id: 'engineering.aerospace', en: 'Aerospace Engineering', ms: 'Kejuruteraan Aeroangkasa' },
            { id: 'engineering.biomedical', en: 'Biomedical Engineering', ms: 'Kejuruteraan Bioperubatan' },
            { id: 'engineering.materials', en: 'Materials Engineering', ms: 'Kejuruteraan Bahan' },
            { id: 'engineering.manufacturing-and-industry', en: 'Manufacturing and Industry', ms: 'Pembuatan dan Industri' },
            { id: 'engineering.control-systems', en: 'Control Systems', ms: 'Sistem Kawalan' },
            { id: 'engineering.construction-technology', en: 'Construction Technology', ms: 'Teknologi Pembinaan' },
        ]),
    }),
    Object.freeze({
        id: 'mathematics',
        en: 'Mathematics and Statistics',
        ms: 'Matematik dan Statistik',
        subcategories: Object.freeze([
            { id: 'mathematics.basic-mathematics', en: 'Basic Mathematics', ms: 'Matematik Asas' },
            { id: 'mathematics.algebra', en: 'Algebra', ms: 'Algebra' },
            { id: 'mathematics.geometry', en: 'Geometry', ms: 'Geometri' },
            { id: 'mathematics.calculus', en: 'Calculus', ms: 'Kalkulus' },
            { id: 'mathematics.applied-mathematics', en: 'Applied Mathematics', ms: 'Matematik Gunaan' },
            { id: 'mathematics.discrete-mathematics', en: 'Discrete Mathematics', ms: 'Matematik Diskret' },
            { id: 'mathematics.number-theory', en: 'Number Theory', ms: 'Teori Nombor' },
            { id: 'mathematics.statistics', en: 'Statistics', ms: 'Statistik' },
            { id: 'mathematics.probability', en: 'Probability', ms: 'Kebarangkalian' },
            { id: 'mathematics.mathematical-modelling', en: 'Mathematical Modelling', ms: 'Pemodelan Matematik' },
        ]),
    }),
    Object.freeze({
        id: 'medicine',
        en: 'Medicine and Health',
        ms: 'Perubatan dan Kesihatan',
        subcategories: Object.freeze([
            { id: 'medicine.clinical-medicine', en: 'Clinical Medicine', ms: 'Perubatan Klinikal' },
            { id: 'medicine.anatomy-and-physiology', en: 'Anatomy and Physiology', ms: 'Anatomi dan Fisiologi' },
            { id: 'medicine.nursing', en: 'Nursing', ms: 'Kejururawatan' },
            { id: 'medicine.pharmacy', en: 'Pharmacy', ms: 'Farmasi' },
            { id: 'medicine.public-health', en: 'Public Health', ms: 'Kesihatan Awam' },
            { id: 'medicine.nutrition', en: 'Nutrition', ms: 'Nutrisi' },
            { id: 'medicine.mental-health', en: 'Mental Health', ms: 'Kesihatan Mental' },
            { id: 'medicine.physiotherapy', en: 'Physiotherapy', ms: 'Fisioterapi' },
            { id: 'medicine.dentistry', en: 'Dentistry', ms: 'Pergigian' },
            { id: 'medicine.veterinary-medicine', en: 'Veterinary Medicine', ms: 'Perubatan Veterinar' },
            { id: 'medicine.care-and-wellness', en: 'Care and Wellness', ms: 'Penjagaan dan Kesejahteraan' },
        ]),
    }),
    Object.freeze({
        id: 'business',
        en: 'Business and Management',
        ms: 'Perniagaan dan Pengurusan',
        subcategories: Object.freeze([
            { id: 'business.entrepreneurship', en: 'Entrepreneurship', ms: 'Keusahawanan' },
            { id: 'business.business-management', en: 'Business Management', ms: 'Pengurusan Perniagaan' },
            { id: 'business.strategic-management', en: 'Strategic Management', ms: 'Pengurusan Strategik' },
            { id: 'business.marketing', en: 'Marketing', ms: 'Pemasaran' },
            { id: 'business.human-resource-management', en: 'Human Resource Management', ms: 'Pengurusan Sumber Manusia' },
            { id: 'business.operations-and-logistics', en: 'Operations and Logistics', ms: 'Operasi dan Logistik' },
            { id: 'business.project-management', en: 'Project Management', ms: 'Pengurusan Projek' },
            { id: 'business.international-trade', en: 'International Trade', ms: 'Perdagangan Antarabangsa' },
            { id: 'business.leadership', en: 'Leadership', ms: 'Kepimpinan' },
            { id: 'business.organisational-management', en: 'Organisational Management', ms: 'Pengurusan Organisasi' },
            { id: 'business.digital-business', en: 'Digital Business', ms: 'Perniagaan Digital' },
        ]),
    }),
    Object.freeze({
        id: 'finance',
        en: 'Finance and Economics',
        ms: 'Kewangan dan Ekonomi',
        subcategories: Object.freeze([
            { id: 'finance.microeconomics', en: 'Microeconomics', ms: 'Mikroekonomi' },
            { id: 'finance.macroeconomics', en: 'Macroeconomics', ms: 'Makroekonomi' },
            { id: 'finance.personal-finance', en: 'Personal Finance', ms: 'Kewangan Peribadi' },
            { id: 'finance.accounting', en: 'Accounting', ms: 'Perakaunan' },
            { id: 'finance.banking', en: 'Banking', ms: 'Perbankan' },
            { id: 'finance.investment', en: 'Investment', ms: 'Pelaburan' },
            { id: 'finance.capital-markets', en: 'Capital Markets', ms: 'Pasaran Modal' },
            { id: 'finance.corporate-finance', en: 'Corporate Finance', ms: 'Kewangan Korporat' },
            { id: 'finance.insurance-and-takaful', en: 'Insurance and Takaful', ms: 'Insurans dan Takaful' },
            { id: 'finance.taxation', en: 'Taxation', ms: 'Percukaian' },
            { id: 'finance.digital-economy', en: 'Digital Economy', ms: 'Ekonomi Digital' },
        ]),
    }),
    Object.freeze({
        id: 'law',
        en: 'Law',
        ms: 'Undang-Undang',
        subcategories: Object.freeze([
            { id: 'law.civil-law', en: 'Civil Law', ms: 'Undang-Undang Sivil' },
            { id: 'law.criminal-law', en: 'Criminal Law', ms: 'Undang-Undang Jenayah' },
            { id: 'law.contract-law', en: 'Contract Law', ms: 'Undang-Undang Kontrak' },
            { id: 'law.corporate-law', en: 'Corporate Law', ms: 'Undang-Undang Korporat' },
            { id: 'law.international-law', en: 'International Law', ms: 'Undang-Undang Antarabangsa' },
            { id: 'law.constitutional-law', en: 'Constitutional Law', ms: 'Undang-Undang Perlembagaan' },
            { id: 'law.family-law', en: 'Family Law', ms: 'Undang-Undang Keluarga' },
            { id: 'law.human-rights', en: 'Human Rights', ms: 'Hak Asasi Manusia' },
            { id: 'law.technology-law', en: 'Technology Law', ms: 'Undang-Undang Teknologi' },
            { id: 'law.intellectual-property', en: 'Intellectual Property Law', ms: 'Undang-Undang Harta Intelek' },
            { id: 'law.public-policy-and-legislation', en: 'Public Policy and Legislation', ms: 'Dasar Awam dan Perundangan' },
        ]),
    }),
    Object.freeze({
        id: 'social-sciences',
        en: 'Social Sciences',
        ms: 'Sains Sosial',
        subcategories: Object.freeze([
            { id: 'social-sciences.sociology', en: 'Sociology', ms: 'Sosiologi' },
            { id: 'social-sciences.psychology', en: 'Psychology', ms: 'Psikologi' },
            { id: 'social-sciences.anthropology', en: 'Anthropology', ms: 'Antropologi' },
            { id: 'social-sciences.political-science', en: 'Political Science', ms: 'Sains Politik' },
            { id: 'social-sciences.international-relations', en: 'International Relations', ms: 'Hubungan Antarabangsa' },
            { id: 'social-sciences.human-geography', en: 'Human Geography', ms: 'Geografi Manusia' },
            { id: 'social-sciences.demography', en: 'Demography', ms: 'Demografi' },
            { id: 'social-sciences.development-studies', en: 'Development Studies', ms: 'Kajian Pembangunan' },
            { id: 'social-sciences.criminology', en: 'Criminology', ms: 'Kriminologi' },
            { id: 'social-sciences.gender-studies', en: 'Gender Studies', ms: 'Kajian Gender' },
            { id: 'social-sciences.public-policy', en: 'Public Policy', ms: 'Dasar Awam' },
        ]),
    }),
    Object.freeze({
        id: 'philosophy',
        en: 'Philosophy and Thought',
        ms: 'Falsafah dan Pemikiran',
        subcategories: Object.freeze([
            { id: 'philosophy.western-philosophy', en: 'Western Philosophy', ms: 'Falsafah Barat' },
            { id: 'philosophy.eastern-philosophy', en: 'Eastern Philosophy', ms: 'Falsafah Timur' },
            { id: 'philosophy.logic', en: 'Logic', ms: 'Logik' },
            { id: 'philosophy.epistemology', en: 'Epistemology', ms: 'Epistemologi' },
            { id: 'philosophy.metaphysics', en: 'Metaphysics', ms: 'Metafizik' },
            { id: 'philosophy.ethics-and-morality', en: 'Ethics and Morality', ms: 'Etika dan Moral' },
            { id: 'philosophy.philosophy-of-science', en: 'Philosophy of Science', ms: 'Falsafah Sains' },
            { id: 'philosophy.political-philosophy', en: 'Political Philosophy', ms: 'Falsafah Politik' },
            { id: 'philosophy.philosophy-of-language', en: 'Philosophy of Language', ms: 'Falsafah Bahasa' },
            { id: 'philosophy.critical-thinking', en: 'Critical Thinking', ms: 'Pemikiran Kritikal' },
            { id: 'philosophy.theory-of-knowledge', en: 'Theory of Knowledge', ms: 'Teori Pengetahuan' },
        ]),
    }),
    Object.freeze({
        id: 'religion',
        en: 'Religion and Spirituality',
        ms: 'Agama dan Kerohanian',
        subcategories: Object.freeze([
            { id: 'religion.islamic-studies', en: 'Islamic Studies', ms: 'Kajian Islam' },
            { id: 'religion.quran-and-tafsir', en: 'Quran and Tafsir', ms: 'Al-Quran dan Tafsir' },
            { id: 'religion.hadith', en: 'Hadith', ms: 'Hadis' },
            { id: 'religion.fiqh', en: 'Fiqh', ms: 'Fiqh' },
            { id: 'religion.aqidah', en: 'Aqidah', ms: 'Akidah' },
            { id: 'religion.history-of-religion', en: 'History of Religion', ms: 'Sejarah Agama' },
            { id: 'religion.comparative-religion', en: 'Comparative Religion', ms: 'Agama Perbandingan' },
            { id: 'religion.theology', en: 'Theology', ms: 'Teologi' },
            { id: 'religion.spirituality', en: 'Spirituality', ms: 'Kerohanian' },
            { id: 'religion.religious-ethics', en: 'Religious Ethics', ms: 'Etika Agama' },
            { id: 'religion.belief-studies', en: 'Belief Studies', ms: 'Kajian Kepercayaan' },
        ]),
    }),
    Object.freeze({
        id: 'history',
        en: 'History and Civilisation',
        ms: 'Sejarah dan Tamadun',
        subcategories: Object.freeze([
            { id: 'history.world-history', en: 'World History', ms: 'Sejarah Dunia' },
            { id: 'history.malaysian-history', en: 'Malaysian History', ms: 'Sejarah Malaysia' },
            { id: 'history.asian-history', en: 'Asian History', ms: 'Sejarah Asia' },
            { id: 'history.european-history', en: 'European History', ms: 'Sejarah Eropah' },
            { id: 'history.african-history', en: 'African History', ms: 'Sejarah Afrika' },
            { id: 'history.middle-eastern-history', en: 'Middle Eastern History', ms: 'Sejarah Timur Tengah' },
            { id: 'history.modern-history', en: 'Modern History', ms: 'Sejarah Moden' },
            { id: 'history.ancient-history', en: 'Ancient History', ms: 'Sejarah Purba' },
            { id: 'history.archaeology', en: 'Archaeology', ms: 'Arkeologi' },
            { id: 'history.military-history', en: 'Military History', ms: 'Sejarah Tentera' },
            { id: 'history.history-of-science-and-technology', en: 'History of Science and Technology', ms: 'Sejarah Sains dan Teknologi' },
            { id: 'history.civilisation-studies', en: 'Civilisation Studies', ms: 'Kajian Tamadun' },
        ]),
    }),
    Object.freeze({
        id: 'education',
        en: 'Education and Teaching',
        ms: 'Pendidikan dan Pengajaran',
        subcategories: Object.freeze([
            { id: 'education.early-childhood', en: 'Early Childhood Education', ms: 'Pendidikan Awal Kanak-Kanak' },
            { id: 'education.primary', en: 'Primary Education', ms: 'Pendidikan Rendah' },
            { id: 'education.secondary', en: 'Secondary Education', ms: 'Pendidikan Menengah' },
            { id: 'education.higher-education', en: 'Higher Education', ms: 'Pendidikan Tinggi' },
            { id: 'education.special-education', en: 'Special Education', ms: 'Pendidikan Khas' },
            { id: 'education.pedagogy', en: 'Pedagogy', ms: 'Pedagogi' },
            { id: 'education.instructional-design', en: 'Instructional Design', ms: 'Reka Bentuk Pengajaran' },
            { id: 'education.educational-technology', en: 'Educational Technology', ms: 'Teknologi Pendidikan' },
            { id: 'education.self-directed-learning', en: 'Self-Directed Learning', ms: 'Pembelajaran Kendiri' },
            { id: 'education.language-education', en: 'Language Education', ms: 'Pendidikan Bahasa' },
            { id: 'education.assessment-and-evaluation', en: 'Assessment and Evaluation', ms: 'Penilaian dan Evaluasi' },
        ]),
    }),
    Object.freeze({
        id: 'language',
        en: 'Language and Linguistics',
        ms: 'Bahasa dan Linguistik',
        subcategories: Object.freeze([
            { id: 'language.malay', en: 'Malay Language', ms: 'Bahasa Melayu' },
            { id: 'language.english', en: 'English Language', ms: 'Bahasa Inggeris' },
            { id: 'language.arabic', en: 'Arabic Language', ms: 'Bahasa Arab' },
            { id: 'language.chinese', en: 'Chinese Language', ms: 'Bahasa Cina' },
            { id: 'language.japanese', en: 'Japanese Language', ms: 'Bahasa Jepun' },
            { id: 'language.korean', en: 'Korean Language', ms: 'Bahasa Korea' },
            { id: 'language.european-languages', en: 'European Languages', ms: 'Bahasa Eropah' },
            { id: 'language.grammar', en: 'Grammar', ms: 'Tatabahasa' },
            { id: 'language.linguistics', en: 'Linguistics', ms: 'Linguistik' },
            { id: 'language.phonetics-and-phonology', en: 'Phonetics and Phonology', ms: 'Fonetik dan Fonologi' },
            { id: 'language.semantics', en: 'Semantics', ms: 'Semantik' },
            { id: 'language.translation', en: 'Translation', ms: 'Terjemahan' },
            { id: 'language.academic-writing', en: 'Academic Writing', ms: 'Penulisan Akademik' },
        ]),
    }),
    Object.freeze({
        id: 'literature',
        en: 'Literature',
        ms: 'Kesusasteraan',
        subcategories: Object.freeze([
            { id: 'literature.malay-literature', en: 'Malay Literature', ms: 'Sastera Melayu' },
            { id: 'literature.english-literature', en: 'English Literature', ms: 'Sastera Inggeris' },
            { id: 'literature.world-literature', en: 'World Literature', ms: 'Sastera Dunia' },
            { id: 'literature.poetry', en: 'Poetry', ms: 'Puisi' },
            { id: 'literature.drama', en: 'Drama', ms: 'Drama' },
            { id: 'literature.short-stories', en: 'Short Stories', ms: 'Cerpen' },
            { id: 'literature.literary-criticism', en: 'Literary Criticism', ms: 'Kritikan Sastera' },
            { id: 'literature.classical-literature', en: 'Classical Literature', ms: 'Sastera Klasik' },
            { id: 'literature.modern-literature', en: 'Modern Literature', ms: 'Sastera Moden' },
            { id: 'literature.childrens-literature', en: "Children's Literature", ms: 'Sastera Kanak-Kanak' },
            { id: 'literature.experimental-literature', en: 'Experimental Literature', ms: 'Sastera Eksperimen' },
        ]),
    }),
    Object.freeze({
        id: 'fiction',
        en: 'Fiction',
        ms: 'Fiksyen',
        subcategories: Object.freeze([
            { id: 'fiction.general-fiction', en: 'General Fiction', ms: 'Fiksyen Umum' },
            { id: 'fiction.contemporary-fiction', en: 'Contemporary Fiction', ms: 'Fiksyen Kontemporari' },
            { id: 'fiction.historical-fiction', en: 'Historical Fiction', ms: 'Fiksyen Sejarah' },
            { id: 'fiction.romance', en: 'Romance', ms: 'Romansa' },
            { id: 'fiction.mystery', en: 'Mystery', ms: 'Misteri' },
            { id: 'fiction.detective-fiction', en: 'Detective Fiction', ms: 'Fiksyen Detektif' },
            { id: 'fiction.thriller', en: 'Thriller', ms: 'Thriller' },
            { id: 'fiction.horror', en: 'Horror', ms: 'Seram' },
            { id: 'fiction.adventure', en: 'Adventure', ms: 'Petualangan' },
            { id: 'fiction.psychological-fiction', en: 'Psychological Fiction', ms: 'Fiksyen Psikologi' },
            { id: 'fiction.political-fiction', en: 'Political Fiction', ms: 'Fiksyen Politik' },
            { id: 'fiction.crime-fiction', en: 'Crime Fiction', ms: 'Fiksyen Jenayah' },
        ]),
    }),
    Object.freeze({
        id: 'scifi-fantasy',
        en: 'Science Fiction and Fantasy',
        ms: 'Fiksyen Saintifik dan Fantasi',
        subcategories: Object.freeze([
            { id: 'scifi-fantasy.hard-science-fiction', en: 'Hard Science Fiction', ms: 'Fiksyen Saintifik Keras' },
            { id: 'scifi-fantasy.soft-science-fiction', en: 'Soft Science Fiction', ms: 'Fiksyen Saintifik Lembut' },
            { id: 'scifi-fantasy.cyberpunk', en: 'Cyberpunk', ms: 'Cyberpunk' },
            { id: 'scifi-fantasy.biopunk', en: 'Biopunk', ms: 'Biopunk' },
            { id: 'scifi-fantasy.space-opera', en: 'Space Opera', ms: 'Opera Angkasa' },
            { id: 'scifi-fantasy.time-travel', en: 'Time Travel', ms: 'Perjalanan Masa' },
            { id: 'scifi-fantasy.alternate-history', en: 'Alternate History', ms: 'Sejarah Alternatif' },
            { id: 'scifi-fantasy.post-apocalyptic', en: 'Post-Apocalyptic Fiction', ms: 'Fiksyen Pasca-Kiamah' },
            { id: 'scifi-fantasy.dystopian', en: 'Dystopian Fiction', ms: 'Fiksyen Dystopia' },
            { id: 'scifi-fantasy.utopian', en: 'Utopian Fiction', ms: 'Fiksyen Utopia' },
            { id: 'scifi-fantasy.epic-fantasy', en: 'Epic Fantasy', ms: 'Fantasi Epik' },
            { id: 'scifi-fantasy.dark-fantasy', en: 'Dark Fantasy', ms: 'Fantasi Gelap' },
            { id: 'scifi-fantasy.urban-fantasy', en: 'Urban Fantasy', ms: 'Fantasi Bandar' },
            { id: 'scifi-fantasy.mythological-fantasy', en: 'Mythological Fantasy', ms: 'Fantasi Mitologi' },
            { id: 'scifi-fantasy.portal-fantasy', en: 'Portal Fantasy', ms: 'Fantasi Portal' },
            { id: 'scifi-fantasy.litrpg', en: 'LitRPG', ms: 'LitRPG' },
        ]),
    }),
]);
//# sourceMappingURL=qx-taxonomy-data-a.js.map